import { RiArrowDropRightLine } from 'react-icons/ri';

import theme from '../../styles/themes/default';

export const ArrowCircleBackground = () => (
  <span
    style={{
      color: theme.colors.orange.primary,
      backgroundColor: theme.colors.white,
      height: 15,
      width: 15,
      borderRadius: 15,
    }}
  >
    <RiArrowDropRightLine />
  </span>
);
